import styles from './index.module.scss'
import SenderMsg from './sender-msg'
import MsgRenderCore from './msg-render-core'
import { observer } from 'mobx-react'
import { useUpdateEffect } from 'ahooks'
import { getStores } from '@/stores'
import React from 'react'
import { FloatButton } from 'antd'
import { VerticalAlignBottomOutlined } from '@ant-design/icons'
import cn from 'classnames'
// import welcomeIcon from '../images/welcome.svg'
import { $t } from '@/i18n/intl'
import { useAutoScroll } from '@/hooks/use-auto-scroll'
import { useAgentWs } from '@/hooks/use-agent-ws'
import LottieHomeIcon from '@/components/lottie-home-icon'

const Main = () => {
  useAgentWs()
  const containerRef = React.useRef<HTMLDivElement>(null)
  const senderOuterBoxRef = React.useRef<HTMLDivElement>(null)
  const { agentV2Store } = getStores()
  const { showScrollButton, hasScrollbar, scrollToBottom, scrollbarWidth } =
    useAutoScroll(containerRef)

  // scrollToBottomViewMark 变化：业务侧请用 requestChatScrollToBottomIfPinned / requestChatScrollToBottomAlways；此处按 consume 的 force 执行
  useUpdateEffect(() => {
    const force = agentV2Store.consumePendingScrollToBottomForce()
    // 使用 setTimeout 确保在下一个事件循环中执行，等待 DOM 更新完成
    const timer = setTimeout(() => {
      scrollToBottom({ force })
    }, 0)
    return () => clearTimeout(timer)
  }, [agentV2Store.scrollToBottomViewMark])

  // 判断是否有消息
  const hasMessages = (agentV2Store?.renderMsgList?.length ?? 0) > 0

  return (
    <div className={styles.container}>
      <div id="ai-agent-main-container" ref={containerRef} className={styles.mainContainer}>
        <div className={styles.innerBox} style={{ position: 'relative' }}>
          <MsgRenderCore />
        </div>
        {/* footer 使用绝对定位，相对于 container 定位 */}
        <div
          ref={senderOuterBoxRef}
          className={cn(styles.senderOuterBox, {
            [styles.center]: !hasMessages,
            [styles.bottom]: hasMessages
          })}
          style={
            hasMessages && hasScrollbar
              ? {
                  right: `${scrollbarWidth}px`
                }
              : undefined
          }
        >
          <div className={styles.senderInnerBox}>
            {!hasMessages ? (
              <div className={styles.welcomeBox}>
                {/* <img className={styles.welcomeIcon} src={welcomeIcon} alt="welcome" /> */}
                <LottieHomeIcon width="60px" height="60px" />
                <span className={styles.welcomeText}>{$t('demo.main.welcomeText')}</span>
              </div>
            ) : null}

            <div className={styles.senderContentBox}>
              <div className={styles.senderBox}>
                <SenderMsg />
              </div>
            </div>
          </div>
        </div>
      </div>

      <FloatButton
        icon={<VerticalAlignBottomOutlined />}
        onClick={() => scrollToBottom({ force: true })}
        style={{
          right: 44,
          bottom: 80,
          display: showScrollButton ? 'block' : 'none',
          position: 'absolute'
        }}
        tooltip={$t('demo.main.scrollToBottom')}
      />
    </div>
  )
}

export default observer(Main)
